import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

/**
 * 盖在页面内容之上（不遮挡顶部栏与底部导航），半透明蒙版 + 居中提示。
 */
export function ComingSoonOverlay({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  return (
    <div className="relative isolate min-h-full overflow-x-hidden">
      {children}
      <div
        className="fixed z-[49] flex items-center justify-center px-6 left-0 right-0 top-0 bottom-0 pointer-events-auto"
        style={{
          background: "rgba(10,11,14,0.88)",
        }}
        aria-hidden
      >
        <p
          className="text-center text-sm font-semibold leading-relaxed max-w-[260px] rounded-xl px-4 py-3"
          style={{
            color: "#e5e7eb",
            background: "rgba(0,0,0,0.35)",
            border: "1px solid rgba(255,255,255,0.08)",
          }}
        >
          {t("common.comingSoon")}
        </p>
      </div>
    </div>
  );
}
